// Best Seller card v3 (bs-product-card-v3.liquid): 3-lens image swiper.
// Clicking a thumbnail swaps the main image, updates the frame/lens subtitle,
// and repoints every PDP link (SHOP NOW, image, title, review) to that variant.
// Function names are namespaced (…V3…) so they never clash with the legacy
// bs-product-card-js.js, which stays loaded as a fallback.
function handleBSV3Swiper() {
  const swipers = document.querySelectorAll(
    "[data-custom-products] .bs-product-card-v2__card .ombraz-product-v2-swiper",
  );

  swipers.forEach((swiper) => {
    const card = swiper.closest(".bs-product-card-v2__card");
    if (!card) return;

    const slides = Array.from(
      swiper.querySelectorAll(".ombraz-product-v2-slide"),
    );
    if (!slides.length) return;

    const featuredImg = card.querySelector("[data-feaure-image]");
    const shopNowLink = card.querySelector("[data-bs-shop-now]");
    const pdpImageLink = card.querySelector("[data-bs-pdp-link]");
    const titleLink = card.querySelector(
      ".bs-product-card-v2__card-title-group",
    );
    const reviewLink = card.querySelector(".klaviyo-star-rating-wrapper");
    const subtitle = card.querySelector(
      ".bs-product-card-v2__card-title-group p",
    );

    function setActiveSlide(activeSlide) {
      slides.forEach((slide) => slide.classList.remove("is-active"));
      activeSlide.classList.add("is-active");
    }

    function applySlide(slide) {
      // 1. Swap the main feature image
      const thumb = slide.querySelector("[data-thumb-image]");
      const imgSrc =
        thumb?.getAttribute("data-thumb-image") || thumb?.getAttribute("src");
      if (featuredImg && imgSrc) {
        requestAnimationFrame(() => {
          featuredImg.setAttribute("src", imgSrc);
        });
      }

      // 2. Update the frame + lens subtitle (mirrors the Liquid markup)
      const frame = slide.getAttribute("data-display-frame") || "";
      const lens = slide.getAttribute("data-display-lens") || "";
      const rawLens = slide.getAttribute("data-raw-lens") || lens;
      if (subtitle) {
        subtitle.innerHTML =
          "<span>" +
          frame +
          '</span><span data-raw-lens-title="' +
          rawLens +
          '">' +
          lens +
          "</span>";
      }

      // 3. Repoint PDP links (data-product-url already carries ?variant=<id>)
      const url = slide.getAttribute("data-product-url");
      if (url) {
        if (shopNowLink) shopNowLink.setAttribute("href", url);
        if (pdpImageLink) pdpImageLink.setAttribute("href", url);
        if (titleLink) titleLink.setAttribute("href", url);
        if (reviewLink) {
          reviewLink.setAttribute(
            "href",
            url.split("#")[0] + "#pdp-review-section",
          );
        }
      }
    }

    slides.forEach((slide) => {
      slide.addEventListener("click", (event) => {
        event.preventDefault();
        event.stopPropagation();
        setActiveSlide(slide);
        applySlide(slide);
      });
    });
  });
}

function handleBSV3Card() {
  handleBSV3Swiper();
}

if (document.readyState !== "loading") {
  handleBSV3Card();
} else {
  document.addEventListener("DOMContentLoaded", handleBSV3Card);
}
